/**
 * Compute allowed redirect origins for Clerk to accept cross-origin redirects.
 * Sources:
 *  - Runtime document.referrer (host embedding our iframe)
 *  - Additional origins from VITE_ALLOWED_REDIRECT_ORIGINS (comma/space separated)
 *
 * The Salesforce-embed-specific hardcoded defaults (vf.force.com,
 * lightning.force.com, my.salesforce.com) were removed with the embed/
 * postMessage integration — see plans/2026-09-24-auth-redesign/phase1-plan.md.
 */
import { config } from './client-config';

export function computeAllowedRedirectOrigins(): string[] {
  const parsedEnvOrigins = config.allowedRedirectOrigins();

  let referrerOrigin: string | undefined;
  try {
    if (typeof document !== 'undefined' && document.referrer) {
      referrerOrigin = new URL(document.referrer).origin;
    }
  } catch { /* ignore */ }

  const candidates = [referrerOrigin, ...parsedEnvOrigins].filter(Boolean) as string[];
  return Array.from(new Set(candidates));
}


